import FootballMark from "./FootballMark";
import styles from "./Logo.module.css";

/**
 * Product wordmark.
 *
 * The name is the joke and the promise, so the two halves are typeset
 * differently: a small, sheepish "I DON'T KNOW" above a confident "FOOTBALL".
 *
 * The football itself lives in ./FootballMark.js, which is the vector of
 * `public/idkf-logo.png`. Every other appearance of the logo in the product
 * (favicon, app icon, share image) is generated from that same source, so
 * there is only ever one football to change.
 *
 * size: "sm" | "md" | "lg"
 * animatedMark: true gives the football a brief intermittent bounce.
 */
const Logo = ({
  size = "md",
  showMark = true,
  animatedMark = false,
  className = "",
}) => {
  const sizeClass = styles[`size_${size}`] ?? styles.size_md;
  const markClass = `${styles.mark} ${
    animatedMark ? styles.markAnimated : ""
  }`.trim();

  return (
    <span className={`${styles.Logo} ${sizeClass} ${className}`.trim()}>
      {showMark && <FootballMark className={markClass} />}
      <span className={styles.words}>
        <span className={styles.prefix}>I don&rsquo;t know</span>
        <span className={styles.name}>FOOTBALL</span>
      </span>
    </span>
  );
};

export default Logo;
